<template>
  <div class="aicePage" :class="[_isMobile() ? 'mobilePage' : '']">
    <template>
        <a-row :gutter="_isMobile() ? [6,6] : [15,15]" >
            <a-col :xs="12" :sm="12" :md="6">
                <div class="aiceEntranceBox" @click="goPageFn('/event/enter')">
                    <img src="../assets/aice2/BMRK.png" alt="">
                    <div class="entranceTips">
                        <p class="p1" style="color: #2A55E5;">报名入口<a-icon type="arrow-right" /></p>
                        <p >点击报名在线测评</p>
                    </div>
                </div>
            </a-col>
            <a-col :xs="12" :sm="12" :md="6">
                <div class="aiceEntranceBox aiceEntranceBox2" @click="goPageFn('/cert/query')">
                    <img src="../assets/aice2/ZSCX.png" alt="">
                    <div class="entranceTips">
                        <p class="p1">证书查询</p>
                        <p >查看成绩、打印证书</p>
                    </div>
                </div>
            </a-col>
            <a-col :xs="12" :sm="12" :md="6">
                <div class="aiceEntranceBox aiceEntranceBox3" @click="goPageFn('/event/MechanismList?type=JG&name=机构查询')">
                    <img src="../assets/aice2/JGCX.png" alt="">
                    <div class="entranceTips">
                        <p class="p1">机构查询</p>
                        <p class="p2">全国21家机构介入查询</p>
                    </div>
                </div>
            </a-col>
            <a-col :xs="12" :sm="12" :md="6">
                <div class="aiceEntranceBox aiceEntranceBox4" @click="goPageFn('/event/MechanismList?type=SFX&name=共建示范校')">
                    <img src="../assets/aice2/GJSFX.png" alt="">
                    <div class="entranceTips">
                        <p class="p1">共建示范校</p>
                        <p >查询共建示范校</p>
                    </div>
                </div>
            </a-col>
        </a-row>
        <!-- 文件通知 -->
        <a-card :bordered="false" class="contentCard" :bodyStyle="cardBodyStyle">
           <div slot="title" class="displayCenterBetween">
            <div class="cardTitle">
                <img src="../assets/aice2/WJTZ_ICON.png" style="width: 20px;height: 20px;margin-right: 8px;" alt="">
                文件通知
            </div>
            <router-link  class="moreCard" :to="{ path: '/cms/list', query: { type: cmsType } }">更多 <a-icon type="right" /></router-link>
           </div>
           <div class="displayCenterBetween">
            <a-row type="flex" style="width: 100%;">
                <a-col :xs="24" :sm="24" :md="12">
                    <img src="../assets/aice2/JZSC.png" ref="fileImageHeight" @load="getFileImageHeight" style="width: 100%;"  alt="">
                </a-col>
                <a-col :xs="24" :sm="24" :md="11" :offset="_isMobile() ? 0 : 1">
                    <ul class="cmsListBox " :class="_isMobile() ? '' : 'scrollbarStyle'" :style="{'height':cmsListBoxHeight+'px'}">
                        <li class="cmsList" v-for="item,index in cmsDataSource1" :key="index" @click="toCmsDetail(item)">
                            <p class="cmsTitle textHidden">{{ item.cmsTitile }}</p>
                            <p class="cmsDesc textHidden">{{ item.cmsDesc}}</p>
                            <p class="smsTimer">{{ item.createTime.split(" ")[0] }}</p>
                        </li>
                    </ul>
                </a-col>
            </a-row>
           </div>
        </a-card>
        <!-- 新闻报道 -->
        <a-card :bordered="false" class="contentCard" :bodyStyle="cardBodyStyle">
           <div slot="title" class="displayCenterBetween">
            <div class="cardTitle">
                <img src="../assets/aice2/XWBD_ICON.png" style="width: 20px;height: 20px;margin-right: 8px;" alt="">
                新闻报道
            </div>
            <router-link  class="moreCard" :to="{ path: '/cms/list', query: { type: cmsType } }">更多 <a-icon type="right" /></router-link>
           </div>
           <div class="displayCenterBetween">
            <a-row type="flex" style="width: 100%;">
                <a-col :xs="24" :sm="24" :md="12">
                    <img src="../assets/aice2/XWBD.png" ref="fileImageHeight" @load="getFileImageHeight" style="width: 100%;"  alt="">
                </a-col>
                <a-col :xs="24" :sm="24" :md="11" :offset="_isMobile() ? 0 : 1">
                    <ul class="cmsListBox " :class="_isMobile() ? '' : 'scrollbarStyle'" :style="{'height':cmsListBoxHeight+'px'}">
                        <li class="cmsList" v-for="item,index in cmsDataSource2" :key="index" @click="toCmsDetail(item)">
                            <p class="cmsTitle textHidden">{{ item.cmsTitile }}</p>
                            <p class="cmsDesc textHidden">{{ item.cmsDesc }}</p>
                            <p class="smsTimer">{{ item.createTime.split(" ")[0] }}</p>
                        </li>
                    </ul>
                </a-col>
            </a-row>
           </div>
        </a-card>
        <!-- 地方动态 -->
        <a-card :bordered="false" class="contentCard" :bodyStyle="cardBodyStyle">
           <div slot="title" class="displayCenterBetween">
            <div class="cardTitle">
                <img src="../assets/aice2/DFDT_ICON.png" style="width: 20px;height: 20px;margin-right: 8px;" alt="">
                地方动态
            </div>
            <router-link  class="moreCard" :to="{ path: '/cms/list', query: { type: cmsType } }">更多 <a-icon type="right" /></router-link>
           </div>
           <div class="displayCenterBetween">
            <a-row type="flex" style="width: 100%;">
                <a-col :xs="24" :sm="24" :md="24" >
                    <ul class="cmsListBox " :class="_isMobile() ? '' : 'scrollbarStyle'" :style="{'height':cmsListBoxHeight+'px'}">
                        <li class="cmsList" v-for="item,index in cmsDataSource3" :key="index" @click="toCmsDetail(item)">
                            <p class="cmsTitle textHidden">{{ item.cmsTitile }}</p>
                            <p class="cmsDesc textHidden">{{ item.cmsDesc }}</p>
                            <p class="smsTimer">{{ item.createTime.split(" ")[0] }}</p>
                        </li>
                    </ul>
                </a-col>
            </a-row>
           </div>
        </a-card>
        <!-- 专家委员会 -->
        <a-card :bordered="false" class="contentCard" :bodyStyle="cardBodyStyleTwo" :style="{'background': _isMobile() ? 'transparent' : '#fff'}">
           <div slot="title" class="displayCenterBetween">
            <div class="cardTitle">
                <img src="../assets/aice2/WJTZ_ICON.png" style="width: 20px;height: 20px;margin-right: 8px;" alt="">
                专家委员会
            </div>
           </div>
           <a-row :gutter="[16,16]" type="flex" :justify=" _isMobile() ? 'start' : 'space-around'">
            <a-col :xs="12" :sm="12" :md="4"  v-for="item,index in peopleDataSource" :key="index" @click="toCmsDetail(item)">
                <div :class="[_isMobile() ? 'cardZjwyj' :''] " style="cursor: pointer;">
                    <img :src="item.cmsCover_url" class="zjwyh_imge" alt="">
                    <div class="zjwyh_name">{{ item.cmsTitile }}</div>
                    <div class="zjwyh_desc">{{ item.cmsDesc }}</div>
                </div>
            </a-col>
           </a-row>
        </a-card>
        <!-- 合作单位 -->

    </template>
  </div>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { getArticleList } from "@/api/article";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import EventApplyModal from "./modal/EventApplyModal";
import PhotoCard from "@/components/common/PhotoCard";
import ImageButton from "@/components/common/ImageButton";
import "@/assets/less/animation.css";
import VueHorizontalTimeline from "@/components/common/VueHorizontalTimeline";
// import LightBox from "vue-image-lightbox";
import { jumpMixins } from "@/utils/jumpMixins";
// require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    PhotoCard,
    VueHorizontalTimeline,
    // LightBox,
    ImageButton,
    EventApplyModal,
  },
  data() {
    return {
      articleList: [],
      videoVisible: false,
      currentVideo: {},
      cmsDataSource1: [],
      cmsDataSource2: [],
      cmsDataSource3: [],
      cmsType: 1,
      videoDataSource: [],
      picDataSource: [],
      tenantConfig: {},
      token: "",
      peopleDataSource: [],
      storeDataSource: [],
      homeEventInfo: null,
      eventList: [],
      timeline: [],
      swiperOptions: {
        speed: 800,
        effect: this._isMobile() ? "fade" : "slide", //"slide" "fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 1,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 700,
          modifier: 0.5,
          slideShadows: false,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
      // lightBoxMedia: [],
      //合作单位LOGO
      comLogo: {
        com1: [],
        com2: [],
        com3: [],
      },
      cmsListBoxHeight:300,
      cardBodyStyle:{},
      cardBodyStyleTwo:{},
      cmsDataSourceList:[1,2,3]

    };
  },
  created() {
    if(this._isMobile()){
        this.cardBodyStyle = {
            'padding':'16px'
        }
        this.cardBodyStyleTwo = {
            'padding':'16px 0 16px 0'
        }
    }
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.comLogo1) {
      this.comLogo.com1 = this.tenantConfig.comLogo1.split(",");
    }
    if (this.tenantConfig.comLogo2) {
      this.comLogo.com2 = this.tenantConfig.comLogo2.split(",");
    }
    if (this.tenantConfig.comLogo3) {
      this.comLogo.com3 = this.tenantConfig.comLogo3.split(",");
    }
    console.log(this.comLogo);
    // this.getHomeEvent();
    this.getEventList();
    // this.getVideoList();
    // this.getPicList();
    this.cmsDataSourceList.forEach(v=>{
        let dataType='cmsDataSource'+v
        this[dataType] = []
        this.getCmsList(v);
    })
    this.getPeopleList();
    // this.getStoreList();
  },
  mounted() {
    this.$nextTick(()=>{
       
    //    this.getFileImageHeight()

    })
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        if (this.$store.state.user.info.thirdType == "cyscc") {
          return (
            "https://cast-files.oss-cn-beijing.aliyuncs.com/" +
            this.$store.state.user.info.avatar
          );
        } else {
          return this.getQiniuUrl(this.$store.state.user.info.avatar);
        }
      } else {
        return require("../assets/avatar2.png");
      }
    },
  },
  methods: {
    tabChange(key) {},
    getUserInfo() {
      getInfo().then((res) => {
        console.log(res);
      });
    },
    getFileImageHeight(event){
        const image = event.target;
        const height = image.naturalHeight * (image.clientWidth / image.naturalWidth);
        console.log('Image height:', height);
        this.cmsListBoxHeight = this._isMobile() ? height + 220 : height
    },
    showApplyEvent() {
      if (Vue.ls.get(ACCESS_TOKEN)) {
        // this.$refs.applyModal.open(this.homeEventInfo.id);
        this.$router.push({
          path: "/event/apply",
          query: { id: this.homeEventInfo.id },
        });
      } else {
        this.toLogin();
      }
    },
    // 四入口事件
    goPageFn(url){
        this.$router.push({path:url})
    },
    // getHomeEvent(){
    //   getAction("/teaching/teachingEvent/getHomeEvent").then(res=>{
    //     if(res.success){
    //       this.homeEventInfo = res.result
    //       this.timeline = this.homeEventInfo.teachingEventScheList.map(s=>{
    //         return {
    //           content: s.scheTime,
    //           title: s.scheDesc
    //         }
    //       })
    //     }else{
    //       this.$message.info(res.message);
    //     }
    //   })
    // },
    getEventList() {
      getAction("/teaching/teachingEvent/getAvailableEvent", {
        eventType: 2,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.eventList = res.result.records;
          if(this.eventList.length == 1){
            this.swiperOptions.loop = false 
          }
        }
      });
    },
    toEventDetail(item) {
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    getCmsList(type) {
      this.cmsType = type;
      let dataType = 'cmsDataSource' + type
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10,
        orderBy: 'time'
      }).then((res) => {
        if (res.success) {
          this[dataType] = res.result.records;
        }
      });
    },

    getVideoList() {
      this.videoDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 5,
        pageSize: 4,
      }).then((res) => {
        if (res.success) {
          this.videoDataSource = res.result.records;
        }
      });
    },
    getPicList() {
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 10,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.picDataSource = res.result.records;
        }
      });
    },
    getPeopleList() {
      this.peopleDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 7,
        pageSize: 999,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.peopleDataSource = res.result.records;
        }
      });
    },
    getStoreList() {
      this.storeDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 4,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.storeDataSource = res.result.records;
        }
      });
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    toCertQuery() {
      let route = this.$router.resolve({
        path: "/cert/query",
      });
      window.open(route.href, "_blank");
    },
    toVideoDetail(item) {
      this.currentVideo = item;
      this.videoVisible = true;
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
    },
    toPicDetail(item) {
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
      let that = this;
      let fileNames = [];
      if (item.extraFilename) {
        fileNames = JSON.parse(item.extraFilename);
        console.log(fileNames);
      }
      if (item.extraFile) {
        // this.lightBoxMedia = item.extraFile.split(",").map((f) => {
        //   let fn = "";
        //   if (f in fileNames) {
        //     fn = fileNames[f];
        //   }
        //   return {
        //     thumb: that.getQiniuUrl(f),
        //     src: that.getQiniuUrl(f),
        //     caption: fn,
        //   };
        // });
        // this.$refs.lightbox.showImage(0);
      } else {
        //this.$message.warning("没有图像")
      }
    },
    getQiniuUrl(text) {
      if (!text) {
        this.$message.warning("未知的文件");
        return;
      }
      if (text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","));
      }
      if (text.startsWith("http")) {
        return text;
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    },
  },
};
</script>
<style lang='less' scoped>
.zjwyh_imge{
    width: 100%;
    height: 211px;
    border-radius: 12px;
    object-fit: cover;
}
.zjwyh_name{
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    padding: 16px 0 8px 0;
}
.zjwyh_desc{
    font-size: 14px;
    color: #64666B;
    line-height: 16px;
}
.contentCard{
    width: 100%;
    border-radius: 8px;
    margin-top: 24px;
}
.cardTitle{
    font-size: 20px;
    color: #323335;
    line-height: 23px;
    display: flex;
    align-items: center;
    font-weight: 600;
}
.moreCard{
    font-size: 14px;
    color: #969AA0;
    line-height: 16px;
}
.cmsListBox{
    list-style: none;
    padding: 0;
    overflow-y: auto;
    .cmsList{
        padding: 8px 12px;
        list-style: none;
        cursor: pointer;
        p{
            margin-bottom: 8px;
        }
        .cmsTitle{
            font-weight: 600;
            font-size: 16px;
            color: #323335;
        }
        .cmsDesc{
            font-size: 14px;
            color: #64666B;
        }
        .smsTimer{
            font-size: 12px;
            color: #969AA0;
            margin: 0 !important;
        }
    }
    .cmsList:hover{
        background: linear-gradient( 138deg, rgba(55,123,255,0.07) 0%, rgba(55,195,255,0.04) 100%);
        border-radius: 8px 8px 8px 8px;
    }
    
}
.mobilePage{
    .cardZjwyj{
        border-radius: 12px;
        min-height: 300px;
        background: #fff;
    }
    .zjwyh_imge{
        width: 100%;
        height: 170px;
        border-radius: 12px 12px 0 0;
        object-fit: cover;
    }
    .zjwyh_name{
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        line-height: 21px;
        padding: 11px 12px 8px 12px;
    }
    .zjwyh_desc{
        font-size: 14px;
        color: #64666B;
        line-height: 18px;
        padding: 0 12px 12px 12px;
    }
    .cardTitle{
        font-size: 17px;
    }
    .cmsListBox{
        margin-top: 12px !important;
        p{
            margin-bottom: 4px;
        }
        .cmsList{
            border-bottom: 1px solid #1618231f !important;
            margin: 0 !important;
            padding: 12px 0 !important;
        }
    }
    .aiceEntranceBox{
        height: 68px;
        padding: 12px;
        border-radius:8px;
        box-shadow:none;
        img{
            width: 32px;
            height: 32px;
        }
        .entranceTips{
            margin-left: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            .p1{
                margin-bottom: 6px !important;
                font-size: 14px;
                line-height: 20px;
                font-weight: bold;
            }
            .p2{
                font-size: 10px;
            }
            p{
                margin: 0;
                font-size: 12px;
                color: #323335;
                line-height: 18px;
            }
        }
    }
    .ant-card-body{
        padding: 16px !important;
    }
}
.aiceEntranceBox{
    width: 100%;
    height: 112px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: linear-gradient( 180deg, #2a56e527 0%, rgba(255,255,255,0) 80%), #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.08);
    border-radius: 12px 12px 12px 12px;
    cursor: pointer;
    img{
        width: 64px;
        height: 64px;
    }
    .entranceTips{
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        .p1{
            margin-bottom: 16px !important;
            font-size: 20px;
            line-height: 23px;
            font-weight: bold;
        }
        p{
            margin: 0;
            font-size: 14px;
            color: #323335;
            line-height: 16px;
        }
    }
}
.aiceEntranceBox2{
    background: linear-gradient( 180deg, #09B16027 0%, rgba(255,255,255,0) 80%), #FFFFFF;
}
.aiceEntranceBox3{
    background: linear-gradient( 180deg, #F6B70C27 0%, rgba(255,255,255,0) 80%), #FFFFFF;
}
.aiceEntranceBox4{
    background: linear-gradient( 180deg, #E3494927 0%, rgba(255,255,255,0) 80%), #FFFFFF;
}
</style>
